import styled from 'styled-components';
import { Link } from 'react-router-dom';

const SearchResultLink = styled(Link)<{ variant: 'compact' | 'standard' }>`
  text-decoration: none;
  color: #17181E;
  background-color: #FFF;
  border-radius: 4px;
  padding: 10px 16px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height:
    ${({ variant }) => {
    switch (variant) {
      case 'compact':
        return '54px';
      case 'standard':
      default:
        return '90px';
    }
  }};
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export default SearchResultLink;
